module.exports = __webpack_public_path__ + "static/media/Poster.c4119381.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/LandingPage/images/Poster.svg
// module id = 949
// module chunks = 0